module.exports = __webpack_public_path__ + "img/ic_settings_lg_hover.04c59ac1.svg";